<template>
  <el-card v-loading="tableLoading">
    <el-row>
      <el-form :model="form" v-bind="formProps.form" :rules="{}">
        <el-form-item align="center" :label="$t('withdrawBank.label.createTime')">
          <el-date-picker v-model="createTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']" :clearable="false" />
        </el-form-item>
        <el-form-item :label="$t('device.serialNumber')" prop="serialNumber">
          <el-input v-model="form.serialNumber" />
        </el-form-item>
        <el-form-item :label="$t('device.phone')" prop="phone">
          <el-input v-model.trim="form.phone" />
        </el-form-item>
        <el-form-item :label="$t('device.tranid')" prop="tranid">
          <el-input v-model.trim="form.tranid" />
        </el-form-item>
        <el-form-item :label="$t('device.tranType')" prop="tranType">
          <!-- <el-input v-model.trim="form.tranType" /> -->
          <el-select v-model="form.tranType">
            <el-option v-for="item in tranTypeStatusOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('device.amount')" prop="amount">
          <el-input v-model.trim="form.amount" />
        </el-form-item>
        <el-form-item :label="$t('device.description')" prop="description">
          <el-input v-model="form.description" />
        </el-form-item>
        <el-form-item :label="$t('device.callbackStatus')" prop="callbackStatus">
          <el-select v-model="form.callbackStatus">
            <el-option v-for="item in callbackStatusOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('device.mo_history.merchantOrderNo')" >
          <el-input v-model.trim="form.merchantOrderNo"  clearable/>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="warning" @click="handleEmpty()">{{
            $t('btns.empty')
          }}</el-button>
          <el-button size="mini" type="primary" @click="handleSearch()">{{
            $t('btns.search')
          }}</el-button>

          <el-button size="mini" type="primary" @click="handleExport()">
            {{ $t('btns.export') }}
          </el-button>
          <!-- <el-button size="mini" type="primary" @click="handleEditor()">{{
            $t('btns.add')
            }}</el-button> -->
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <div class="header-table" v-if="totalData">
        <ul class="list-table">
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('device.orderNumberTotal') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.orderNumberTotal | toThousands }}
            </span>
          </li>
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('orders.label.list.totalSuccessMoney') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.paymentAmountTotal | toThousands }}
            </span>
          </li>
        </ul>
      </div>
      <el-table :data="tableList" stripe class="table" ref="table" :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }" >
        <!-- <el-table-column type="index" label="#"></el-table-column> -->
        <!-- <el-table-column  prop="id" align="center" :label="$t('device.mo_history.id')" /> -->
        <el-table-column prop="merchantOrderNo" align="center" :label="$t('device.mo_history.merchantOrderNo')" />
        <el-table-column prop="merchantNo" align="center" :label="$t('device.mo_history.merchantNo')" />
        <el-table-column prop="serialNumber" align="center" :label="$t('device.mo_history.serialNumber')" />
        <el-table-column prop="phone" align="center" :label="$t('device.mo_history.phone')" />
        <!-- <el-table-column  prop="userName" align="center" :label="$t('device.mo_history.userName')" /> -->
        <el-table-column prop="tranid" align="center" :label="$t('device.mo_history.tranid')" />
        <el-table-column prop="tranType" align="center" :label="$t('device.mo_history.tranType')">
          <template slot-scope="{ row }">
            {{ $getStatus($t('device.transpayTo'), row.tranType) }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" align="center" :label="$t('device.mo_history.amount')">
          <template slot-scope="{ row }">
            {{ row.amount | toThousands }}
          </template>
        </el-table-column>
        <el-table-column prop="description" align="center" :label="$t('device.mo_history.description')" />
        <!-- <el-table-column  prop="partnerId" align="center" :label="$t('device.mo_history.partnerId')" /> -->
        <!-- <el-table-column  prop="partnerName" align="center" :label="$t('device.mo_history.partnerName')" /> -->
        <el-table-column prop="payTime" align="center" :label="$t('device.mo_history.payTime')" />
        <el-table-column prop="createTime" align="center" :label="$t('device.mo_history.createTime')" />
        <!-- <el-table-column  prop="merchantName" align="center"
          :label="$t('device.mo_history.merchantName')" /> -->
        <!-- <el-table-column align="center" :label="$t('channel.label.action')">
          <template slot-scope="{ row }">
            <el-popconfirm :ref="`popover-${row.id}`" :key="row.id" :title="$t('orders.tip.danger')"
              @confirm="handleEditor(row)">
              <el-button slot="reference" type="primary" size="mini">
                {{ $t('btns.editor') }}
              </el-button>
            </el-popconfirm>
            <el-popconfirm :ref="`popover-${row.id}`" :key="row.id+'s'" :title="$t('orders.tip.danger')"
              @confirm="handleDel(row)">
              <el-button slot="reference" type="danger" size="mini">
                {{ $t('btns.del') }}
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column> -->
      </el-table>
    </el-row>

    <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />

    <v-editor ref="editor" :statusData="statusData" :serviceTypes="serviceTypes" :rules="formProps.form.rules"
      :channelTypeList="channelTypeList" :channelTypeData="channelTypeData" @doConfAdd="doConfAdd"
      @doConfUpdate="doConfUpdate" />
  </el-card>
</template>

<script>
  import {
    debounce
  } from 'lodash';
  import device_API from '@/api/device';
  import vEditor from './editor';
  import base from '@/mixin/base.js';
  export default {
  mixins: [base],
    components: {
      vEditor
    },
    data() {
      return {
        tableLoading:false,
        form: {
          serialNumber: null,
          phone: null,
          tranid: null,
          tranType: null,
          amount: null,
          description: null,
          merchantOrderNo:null,
        },
        createTime: null,
        pagination: {
          no: 1,
          size: 100
        },
        callbackStatusOption: this.$t('device.callbackStatusOption'),
        tranTypeStatusOption: this.$t('device.b_transpayTo'),
        channelTypeData: {},
        tableData: {},
        totalData: null
      };
    },
    computed: {
      tableList() {
        return this.tableData.list || [];
      },
      channelTypeList() {
        return Object.keys(this.channelTypeData) || [];
      },
      channelCodeList() {
        if (Array.isArray(this.channelTypeData[this.form.channelType])) {
          return this.channelTypeData[this.form.channelType].length > 0 ?
            this.channelTypeData[this.form.channelType] :
            '';
        } else {
          return '';
        }
      },
      statusData() {
        return [{
            label: this.$t('status.success2'),
            type: 'success',
            value: 1
          },
          {
            label: this.$t('status.error2'),
            type: 'error',
            value: 0
          }
        ];
      }
    },
    created() {
      function getdate() {
        var date = new Date();
        var seperator1 = '-';
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = '0' + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = '0' + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
      }
      this.createTime = [getdate() + ' 00:00:00', getdate() + ' 23:59:59'];
      this.init();
    },
    mounted() {
      // this.getConfType();
      this.getTableData();
      this.getTableTotal();
    },
    methods: {
      init() {
        this.handleSearch = debounce(this._handleSearch, 300);

        /* ----------------------------- element -props ----------------------------- */
        this.formProps = {
          form: {
            ref: 'form',
            'label-width': 'auto',
            inline: true,
            size: 'small',
            rules: {
              channelCode: [{
                required: true,
                message: this.$t('channel.rules.channelCode'),
                trigger: 'change'
              }],
              channelType: [{
                required: true,
                message: this.$t('channel.rules.channelType'),
                trigger: 'change'
              }]
            }
          }
        };
        this.serviceTypes = ['api', 'auto'];
      },

      /* ---------------------------------- 格式化数据 --------------------------------- */
      formatParams() {
        return {
          ...Object.keys(this.form).reduce((acc, key) => {
            if (this.form[key] === 0 || this.form[key]) {
              acc[key] = this.form[key];
            }
            if (key === 'channelCode') {
              acc.channelCode = '';
            }
            return acc;
          }, {})
          // ...this.pagination
        };
      },
      /* --------------------------------- 获取分页数据 --------------------------------- */
      async getTableData() {
        this.tableLoading = true;
        let param = this.form;
        if (this.createTime) {
          let [beginTime, endTime] = this.createTime;
          param.beginTime = beginTime;
          param.endTime = endTime;
        }

        const {
          data
        } = await device_API.m_h_list({
          query: this.form,
          no: this.pagination.no,
          size: this.pagination.size
        });
        if (data && data.code == 200) {
          this.tableData = data.data;
          this.tableLoading = false;
        }else {
          this.tableLoading = false;
          this.$message.error(data.msg);
        }
      },
      async getTableTotal() {
        let param = this.form;
        if (this.createTime) {
          let [beginTime, endTime] = this.createTime;
          param.beginTime = beginTime;
          param.endTime = endTime;
        }

        const {
          data
        } = await device_API.m_h_statistics(this.form);
        if (data && data.code == 200) {
          this.totalData = data.data;
        }
      },
      async handleExport() {
        const {
          data
        } = await device_API.doExport(this.formatParams(), 'momo');
        if (data) {
          const BLOB = data;
          const fileReader = new FileReader();
          fileReader.readAsDataURL(BLOB);
          fileReader.onload = (event) => {
            // 处理load事件。该事件在读取操作完成时触发
            // 新建个下载的a标签，完成后移除。
            let a = document.createElement('a');
            a.download = `Merchant-WithdrawList${Number(new Date())}.xlsx`;
            a.href = event.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        } else {
          this.$message.error(this.$t('status.error'));
        }
      },

      formatParams() {
        const [createTimeStart, createTimeEnd] = this.createTime;
        return {
          ...Object.keys(this.form).reduce((acc, key) => {
            acc[key] = this.form[key];
            return acc;
          }, {}),
          beginTime: createTimeStart,
          endTime: createTimeEnd
        };
      },
      async getConfType() {
        const {
          data
        } = await device_API.confType();
        if (data && data.code == 200) {
          this.channelTypeData = data.data;
        }
      },

      async doConfAdd(formUpdate, cb) {
        const params = {
          ...formUpdate
        };
        const {
          data
        } = await device_API.insert(params);
        if (data.code == 200) {
          cb();
        } else {
          this.$message.error(data.msg);
        }
        this.getTableData();
        this.getTableTotal();
      },

      async doConfUpdate(formUpdate, cb) {
        const params = {
          ...formUpdate
        };
        const {
          data
        } = await device_API.update(params);
        if (data.code == 200) {
          cb();
        } else {
          this.$message.error(data.msg);
        }
        this.getTableData();
        this.getTableTotal();
      },
      /* --------------------------------- 事件驱动函数 --------------------------------- */
      handleEmpty() {
        this.form = {
          //连接状态0断开1连接
          connectionStatus: null,
          //设备号
          serialNumber: '',
          //手机号
          phone: '',
          //限额
          limits: null
        };
        this.resetPagination();
        this.resetTimer();
      },
      handleEditor(row) {
        this.$refs.editor.init(row);
      },
      async handleDel(row) {
        const {
          data
        } = await device_API.deletes(row.id);
        if (data.code == 200) {} else {
          this.$message.error(data.msg);
        }
        this.getTableData();
        this.getTableTotal();
      },
      _handleSearch() {
        this.$refs.form.validate(
          async (valid) => valid && this.getTableData() && this.getTableTotal()
        );
      }
    }
  };

</script>

<style scoped>
  .header-table {
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.2);
    padding-right: 40px;
  }

  .header-table .list-table {
    display: flex;
    list-style: none;
  }

  .header-table .list-table li {
    display: flex;
    list-style: none;
  }

  .header-table .list-table li .label {
    font-style: normal;
  }

  .header-table .list-table li .value {
    display: flex;
    list-style: none;
  }

  .header-table .list-table li:nth-child(n + 2) {
    margin-left: 30px;
  }

  .header-table .btn-table {
    margin-left: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/device/momohistory.vue